var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAlcohol = function SvgAlcohol(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Alcohol_svg__clip0_1120_205135)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.567 3.037l-.149-.472-.015.001H5.505l-.149.47a3.558 3.558 0 00-.238 1.258l.267.284H8.53l.275-.284a3.558 3.558 0 00-.239-1.257z",
    fill: "url(#Alcohol_svg__paint0_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.005 11.895v8.684a1.428 1.428 0 00.877 1.312c-.168.07-.352.11-.545.11H4.669a1.395 1.395 0 01-1.398-1.393v-8.805c0-.883.329-1.735.923-2.39a3.563 3.563 0 00.922-2.392V4.319v-.013-.011h3.689V7.02c0 .748.321 1.473.754 2.076a1.153 1.153 0 00-.042.308c0 .206.14.483.234.65l.001.002H9.54a.532.532 0 00-.534.53v1.308z",
    fill: "url(#Alcohol_svg__paint1_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.272 11.896h5.725v7.377H3.272v-7.377z",
    fill: "url(#Alcohol_svg__paint2_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.272 13.513h5.725v4.142H3.272v-4.142z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.2 3.036l.149-.47h-1.83l-.008-.001h-.006l-.15.47a3.558 3.558 0 00-.238 1.258v.012l-.001.013V7.02c0 .883-.329 1.735-.922 2.39a3.563 3.563 0 00-.923 2.392v8.805c0 .769.626 1.392 1.398 1.392h1.886c-.702 0-1.27-.623-1.27-1.392V11.802c0-.883.298-1.735.838-2.391A3.77 3.77 0 006.96 7.02V4.305l.001-.011c.002-.43.082-.857.237-1.258z",
    fill: "url(#Alcohol_svg__paint3_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.403 1H5.521a.52.52 0 00-.519.517v.617a.52.52 0 00.519.517h2.882a.52.52 0 00.519-.517v-.617A.52.52 0 008.403 1z",
    fill: "url(#Alcohol_svg__paint4_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M6.846 2.15V1.5c0-.224.138-.417.334-.5H5.52a.52.52 0 00-.518.517v.617a.52.52 0 00.519.517H7.18a.546.546 0 01-.334-.5z",
    fill: "url(#Alcohol_svg__paint5_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.242 11.007v-.505a.532.532 0 00-.533-.531H9.455a.532.532 0 00-.534.53v1.478h7.236v.32h1.512c.293 0 .533.238.533.531v6.023c0 .292-.24.53-.534.53h-1.511v1.195c0 .033-.002.065-.004.098h1.516c1.009 0 1.83-.818 1.83-1.823V12.83a1.829 1.829 0 00-1.83-1.823h-1.427z",
    fill: "url(#Alcohol_svg__paint6_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.518 11.008h-1.362V12.3h1.362v-1.292z",
    fill: "url(#Alcohol_svg__paint7_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M17.518 19.385h-1.362v1.194c0 .033-.001.065-.003.098h1.361a1.49 1.49 0 00.004-.098v-1.194z",
    fill: "url(#Alcohol_svg__paint8_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.224 20.806a1.43 1.43 0 00.019-.227v-8.684H8.922v8.684c0 .077.006.153.018.227h7.284z",
    fill: "url(#Alcohol_svg__paint9_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.925 20.68c.052.738.669 1.32 1.423 1.32h4.468c.754 0 1.37-.582 1.422-1.32H8.925z",
    fill: "url(#Alcohol_svg__paint10_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.039 9.97H9.455a.532.532 0 00-.534.532v10.076a1.42 1.42 0 001.427 1.421h1.584c-.71 0-1.299-.517-1.408-1.194a1.192 1.192 0 01-.015-.126 1.396 1.396 0 01-.003-.101V10.502c0-.293.238-.531.533-.531z",
    fill: "url(#Alcohol_svg__paint11_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.822 15.062a.562.562 0 10.002-1.124.562.562 0 00-.002 1.124zM11.876 18.024c.597 0 1.08-.482 1.08-1.076 0-.595-.483-1.077-1.08-1.077-.597 0-1.08.482-1.08 1.077 0 .594.483 1.076 1.08 1.076z",
    fill: "#E3D06E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.789 14.501c0-.214.12-.4.298-.494a.561.561 0 100 .989.56.56 0 01-.298-.495zM11.709 16.948c0-.432.255-.805.624-.976a1.081 1.081 0 00-1.538.976 1.079 1.079 0 001.538.975 1.076 1.076 0 01-.624-.975z",
    fill: "#FFF8CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.86 8.268a.389.389 0 01-.305-.293c-.178-.754-1.071-1.12-1.73-.715a.388.388 0 01-.407 0c-.659-.404-1.553-.04-1.73.715a.389.389 0 01-.306.293c-.538.1-.948.57-.948 1.136 0 .17.002.359.056.514.02.057.076.095.137.095h3.248c.117 0 .212.095.212.212v1.897c0 .266.218.504.485.511.182.005.304-.088.39-.23.033-.055.12-.031.12.034v.702c0 .274.214.509.489.513a.496.496 0 00.505-.495v-2.932c0-.117.095-.211.213-.211l.318-.001a.146.146 0 00.137-.096c.056-.155.064-.344.064-.513 0-.566-.41-1.037-.948-1.136z",
    fill: "url(#Alcohol_svg__paint12_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.854 12.122v-1.896a.212.212 0 00-.213-.212h-.765c.117 0 .212.095.212.212v1.896c0 .266.218.505.484.511.176.005.295-.081.38-.213a.514.514 0 01-.098-.298z",
    fill: "url(#Alcohol_svg__paint13_linear_1120_205135)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M10.393 10.013a.144.144 0 01-.136-.095c-.054-.155-.056-.344-.056-.513 0-.567.41-1.037.947-1.137a.389.389 0 00.306-.293c.095-.402.393-.693.751-.817-.624-.22-1.357.142-1.516.817a.389.389 0 01-.306.293c-.538.1-.947.57-.947 1.137 0 .169.002.358.055.513.02.057.076.095.137.095h.765z",
    fill: "url(#Alcohol_svg__paint14_linear_1120_205135)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint0_linear_1120_205135",
    x1: 6.962,
    y1: 2.565,
    x2: 6.962,
    y2: 6.348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint1_linear_1120_205135",
    x1: 6.825,
    y1: 4.295,
    x2: 6.825,
    y2: 22.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint2_linear_1120_205135",
    x1: 6.135,
    y1: 11.896,
    x2: 6.135,
    y2: 19.273,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7573"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E74744"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint3_linear_1120_205135",
    x1: 8.283,
    y1: 0.999,
    x2: 2.795,
    y2: 22.954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint4_linear_1120_205135",
    x1: 6.962,
    y1: 1,
    x2: 6.962,
    y2: 2.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA8A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF7A77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint5_linear_1120_205135",
    x1: 7.679,
    y1: 0.867,
    x2: 7.6,
    y2: 2.845,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint6_linear_1120_205135",
    x1: 13.056,
    y1: 9.829,
    x2: 14.249,
    y2: 21.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9FAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#96E1F8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint7_linear_1120_205135",
    x1: 17.83,
    y1: 10.904,
    x2: 17.753,
    y2: 12.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint8_linear_1120_205135",
    x1: 17.831,
    y1: 19.281,
    x2: 17.754,
    y2: 20.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint9_linear_1120_205135",
    x1: 12.858,
    y1: 11.895,
    x2: 12.858,
    y2: 20.806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFEB99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3D661"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint10_linear_1120_205135",
    x1: 12.857,
    y1: 20.68,
    x2: 12.857,
    y2: 22,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E7C53D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5B32A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint11_linear_1120_205135",
    x1: 12.622,
    y1: 9.002,
    x2: 9.725,
    y2: 22.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint12_linear_1120_205135",
    x1: 12.861,
    y1: 7.093,
    x2: 12.861,
    y2: 13.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF4C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0CE45"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint13_linear_1120_205135",
    x1: 14.198,
    y1: 9.803,
    x2: 13.803,
    y2: 12.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Alcohol_svg__paint14_linear_1120_205135",
    x1: 12.84,
    y1: 6.859,
    x2: 12.647,
    y2: 10.352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.964
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Alcohol_svg__clip0_1120_205135"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h22v22H0z"
  })))));
};
export default __webpack_public_path__ + "static/media/Alcohol.ccf21f4f.svg";
export { SvgAlcohol as ReactComponent };